<template>
	<div>
		<h2 class="text-center text-[20px] leading-[28px] font-semibold text-gray-900">
			One thing worth trying
		</h2>
		<p class="mt-0.5 text-center text-[14px] leading-[20px] font-normal text-gray-500">
			Your must-have filters might be hiding relevant roles.
			You can manage them anytime via Job Board Settings.
		</p>

		<button
			type="button"
			class="
				mx-auto mt-6 flex h-9 w-full max-w-[320px] items-center justify-center rounded-md
				bg-won-green px-3 text-[16px] leading-[20px] font-medium text-white
				hover:bg-won-green-dark
			"
			@click="emit('open-settings')"
		>
			Open Job Board Settings
		</button>

		<button
			type="button"
			class="
				mx-auto mt-2 flex h-9 w-full max-w-[320px] items-center justify-center rounded-md
				bg-gray-100 px-3 text-[16px] leading-[20px] font-medium text-gray-900 hover:bg-gray-200
			"
			@click="emit('cancel')"
		>
			Cancel Subscription
		</button>
	</div>
</template>

<script setup>
// Neither button does async work: the primary one leaves the flow for the drawer, and the
// secondary one only moves to the feedback step, so there is no submitting state here.
const emit = defineEmits(['open-settings', 'cancel']);
</script>
